import { ref, computed, Ref } from 'vue'

export default (last: Ref, defaultH = 48): [Ref<boolean>, Ref<string>] => {
  const collapse = ref(true)
  const height = computed(() => {
    const len = last.value.length
    if (len > 4) {
      return (collapse.value ? 4 : len) * defaultH + 'px'
    } else {
      return len * defaultH + 'px'
    }
  })
  return [collapse, height]
}
